import { graphql, commitMutation } from 'react-relay';

const mutation = graphql`
    mutation SharedSaveSearchMutation(
        $searchTypes: [types]
        $searchPages: [String]
        $input: FavoritePageInput!
    ) {
        favoritePage(input: $input) {
            user {
                savedSearches: favorites(first: 1, types: $searchTypes, pages: $searchPages) {
                    edges {
                        node {
                            serviceId
                        }
                    }
                }
            }
        }
    }
`;

function commit(environment, { page, name, favoritedSearchId, type = 'SEARCH', ...props }) {
    const input = {
        page,
        type,
        name,
        userId: props.userId,
        favoriteId: favoritedSearchId,
        action: favoritedSearchId ? 'REMOVE' : 'ADD',
    };

    commitMutation(environment, {
        mutation,
        variables: {
            input,
            searchPages: page ? [page] : null,
            searchTypes: type ? [type] : null,
        },
        onCompleted: props.onCompleted,
        onError: props.onError,
    });
}

export const SharedSaveSearch = {
    commit,
};
